import React from 'react'


export default function Spinner({width, height, color, color1, color2, alt}) {
  return (
    <div
      className='spinner'
      style={{
        width: `${width || 40}px`,
        height: `${height || 40}px`,
      }}
    >
      <div
        className='double-bounce1'
        style={{
          backgroundColor: color1 || color || '#333',
        }}
      />
      <div
        className='double-bounce2'
        style={{
          backgroundColor: color2 || color || '#333',
          animationDelay: alt ? '-2.5s' : '-1.0s',
        }}
      />
    </div>
  )
}
